<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">{{"NOTIFICATIONS.TEXT" | translate}}</div>
      <div class="dropdown-subheading">
        {{"YOU_HAVE.TEXT" | translate}} {{ notificationTotalCount }}  {{"NEW_NOTIFICATIONS.TEXT" | translate}}
      </div>
    </div>

    <!-- <button [matMenuTriggerFor]="settingsMenu" mat-icon-button type="button">
      <mat-icon
        class="notifications-header-icon"
        svgIcon="mat:settings"></mat-icon>
    </button> -->
  </div>

  <div class="dropdown-content" >
    <div *ngIf="notificationTotalCount == 0">
      <p class="text-muted p-3 text-center">{{"THERE_ARE_NO_NOTIFICATIONS.TEXT" | translate}}</p>
    </div>
    <a 
    *ngFor="let notification of notifications | async; trackBy: trackById"
      [routerLink]="navigationRoute"
      class="notification flex items-center"
      matRipple
      (click)="readOneNotification(notification)">
      <mat-icon
        svgIcon="mat:notifications_active"
        class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label"> {{
          environmentType == 'main-portal' 
            ? (notificationType[notification.type]?.toUpperCase() + '.TEXT' | translate) 
            : (notification.type == 3 
                ? ('ORDERS-TRACKING.TEXT' | translate) 
                : (notificationType[notification.type]?.toUpperCase() + '.TEXT' | translate))
        }} ( {{notification.objectRef}} ) {{ 'NOTIFY::'+notificationOperation[notification.operation].toUpperCase()+'.TEXT'|translate}}</div>
        <div class="notification-description">
          {{ notification.createdAt | vexDateFormatRelative }}
        </div>
      </div>
      <!-- <mat-icon
        class="notification-chevron flex-none"
        svgIcon="mat:chevron_right"></mat-icon> -->
    </a>
    <a *ngIf="index < numberOfPages" (click)="LoadMoreNotifications()" class="notification flex items-center load-more">Load More Notifications</a>
  </div>

  <div *ngIf="notificationTotalCount" class="dropdown-footer flex items-center justify-center">
    <button  color="primary" mat-button type="button" (click)="readAllNotifications()">{{"MARK_ALL_AS_READ.TEXT"|translate}}</button>
  </div>
</div>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item>
    <mat-icon svgIcon="mat:clear_all"></mat-icon>
    <span>Mark all as read</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:notifications_off"></mat-icon>
    <span>Disable Notifications</span>
  </button>
</mat-menu>
